import { combineReducers } from 'redux';
import productReducer from './productReducer';
import categories from './categoriesReducer';
import currencies from './currencies.reducer';
import auth from './authReducer';
import isPageLoading from './pageLoadingReducer';
import order from './order.reducer';
import statistic from './userStatisticReducer';
import reviews from './reviewsReducer';
import notifications from './notificationsReducer';
import balances from './balancesReducer';
import message from './messageReducer';
import language from './languageReducer';
import collections from './collectionReducer';
import theme from './themeReducer';

const rootReducer = {
  auth,
  products: productReducer,
  categories,
  isPageLoading,
  currencies,
  order,
  statistic,
  reviews,
  notifications,
  balances,
  message,
  language,
  collections,
  theme
};

export default combineReducers(rootReducer);
